import { AppRoute } from ':cloud/utils/routes';
import { RoutedTabbedChips } from ':cloud/widgets/sharedcomponents/RoutedTabbedChip';

const tabs = [
  {
    id: 'apiKeys',
    label: 'Secret API Keys',
    route: AppRoute.Projects.APIKeys,
  },
  {
    id: 'clientKey',
    label: 'Client API Key',
    route: AppRoute.Projects.ClientKey,
  },
  {
    id: 'oauth',
    label: 'OAuth',
    route: AppRoute.Projects.KeysOAuth,
  },
];

export default function APIKeyTabs() {
  return <RoutedTabbedChips tabs={tabs} />;
}
